export default "__VITE_ASSET__D3TANY9a__"